import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { isMobileUA } from 'dpl/shared/utils';
import { searchBreedsResourceDefinition, fuzzySearchBreedsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import BreedSearchResults from 'dpl/components/BreedSearch/BreedSearchResults';
import MobileBreedSearchResults from 'dpl/components/BreedSearch/MobileBreedSearchResults';

const IS_MOBILE_UA = isMobileUA();

function BreedSearchResultsContainer(props) {
  return IS_MOBILE_UA
    ? <MobileBreedSearchResults { ...props } />
    : <BreedSearchResults { ...props } />;
}

export default compose(
  __DEPRECATED_defineResources((state, { isOpen, query }) => {
    const shouldFetchData = !IS_MOBILE_UA || isOpen || window.__DPL_BOT_UA;

    return {
      searchResults: {
        ...searchBreedsResourceDefinition(),
        auto: shouldFetchData
      },
      fuzzySearchResults: {
        ...fuzzySearchBreedsResourceDefinition(query),
        auto: shouldFetchData
      }
    };
  }),
  connect((_, { searchResults, fuzzySearchResults, query }) => ({
    breeds: query ? fuzzySearchResults.value.data : searchResults.value.data,
    isLoading: !searchResults.meta.isSuccess
  }))
)(BreedSearchResultsContainer);
